import React, { useEffect, useState } from "react";
import RestrictedWebhookOptionWrapper from "../../RestrictedWebhookOptionWrapper";
import { SelectedWebhookType } from "../../../enums";
import { RefreshCcwIcon } from "lucide-react";
import WebhookSelectCard from "./WebhookSelectCard";
import CommonModelSelect from "../../CommonModelSelect";
import { Accordion } from "react-bootstrap";
import { CategoryMap } from "../../../hooks/useWebhookOptions";
import { Text } from "@merge-api/merge-javascript-shared";
import { APICategory } from "../../../../../../../../models/Entities";

interface CommonModelSyncWebhookProps {
  onSelectedWebhookTypeChange: (selectedWebhookType: SelectedWebhookType) => void;
  onUnselectingWebhookType: (selectedWebhookType: SelectedWebhookType) => void;
  selectedWebhookType: Set<SelectedWebhookType>;

  // common model select props

  onSelectedSyncCategoriesChange: (selectedCategories: APICategory[]) => void;
  selectedSyncCategories: APICategory[];

  modelToCategoryMap: CategoryMap;
  selectedCommonModels: string[];
  selectedCommonModelEvents: string[];
  syncCommonModelsFromEvents: string[];
  onSelectedCommonModelsChange: (selectedCommonModels: string[]) => void;
  onSelectedCommonModelEventsChange: (selectedCommonModelEvents: string[]) => void;
}

function CommonModelSyncWebhook(props: CommonModelSyncWebhookProps) {
  const {
    onSelectedSyncCategoriesChange,
    selectedSyncCategories,
    syncCommonModelsFromEvents,
    onSelectedWebhookTypeChange,
    modelToCategoryMap,
    selectedWebhookType,
    selectedCommonModels,
    selectedCommonModelEvents,
    onSelectedCommonModelsChange,
    onSelectedCommonModelEventsChange,
    onUnselectingWebhookType,
  } = props;

  const isSelected =
    selectedWebhookType.has(SelectedWebhookType.COMMON_MODEL_SYNC_SELECT) ||
    selectedWebhookType.has(SelectedWebhookType.COMMON_MODEL_SYNC_ANY);

  const [accordionKey, setAccordionKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isSelected) {
      setAccordionKey("0");
    } else {
      setAccordionKey(undefined);
    }
  }, [isSelected]);

  return (
    <RestrictedWebhookOptionWrapper>
      <Accordion defaultActiveKey={accordionKey}>
        <WebhookSelectCard
          title="Common Model synced"
          description="Receive an alert when selected Common Models are synced. This option is best if you have a lot of data to keep in sync."
          icon={<RefreshCcwIcon size={16} />}
          onClick={() => {
            if (isSelected) {
              onUnselectingWebhookType(SelectedWebhookType.COMMON_MODEL_SYNC_ANY);
              onUnselectingWebhookType(SelectedWebhookType.COMMON_MODEL_SYNC_SELECT);
            } else {
              if (syncCommonModelsFromEvents.length === 0) {
                onSelectedWebhookTypeChange(SelectedWebhookType.COMMON_MODEL_SYNC_ANY);
              } else if (syncCommonModelsFromEvents.length > 0) {
                onSelectedWebhookTypeChange(SelectedWebhookType.COMMON_MODEL_SYNC_SELECT);
              }
            }
          }}
          selected={isSelected}
          selectedWebhookType={selectedWebhookType}
        >
          <div className="flex flex-col mt-5">
            <div className="flex flex-row justify-between items-center flex-wrap mb-2">
              <Text variant="h6">Select category or categories</Text>
            </div>
            <CommonModelSelect
              onSelectedCategoriesChange={onSelectedSyncCategoriesChange}
              selectedCategories={selectedSyncCategories}
              selectedWebhookType={selectedWebhookType}
              modelToCategoryMap={modelToCategoryMap}
              selectedCommonModels={selectedCommonModels}
              selectedCommonModelEvents={selectedCommonModelEvents}
              onSelectedCommonModelsChange={onSelectedCommonModelsChange}
              onSelectedCommonModelEventsChange={onSelectedCommonModelEventsChange}
              setSelectedChangedDataCommonModelsToFields={() => {}}
              setSelectedChangedDataCommonModelsToEnumOrigins={() => {}}
              currentSection={SelectedWebhookType.COMMON_MODEL_SYNC_ANY}
            />
          </div>
        </WebhookSelectCard>
      </Accordion>
    </RestrictedWebhookOptionWrapper>
  );
}

export default CommonModelSyncWebhook;
